<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">1920: A Year of Global Turmoil</h1>
<p class="author">David Charlwood</p>
<div class="img_container"><img alt="images" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1d805983